'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var breakpoints = require('./breakpoints-5748ddd8.js');
var hooks_useCombinedClassName = require('./hooks/use-combined-class-name/index.js');
var element = require('./element-eba06ad0.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["className"];

/**
 * A wrapper around our {@link OwnUpGridItem} component that
 *   contains nothing in it and occupies the rest of the grid
 *   row.
 *
 * You should only use this when you need to force a grid break.
 *   You should avoid using these when it's not necessary (i.e.
 *   you already have 12 columns used.) Though the CSS will ensure
 *   that they do not cause extra voidspace.
 *
 * Can use the breakpoint args (`xs`, `sm`, `md`, `lg`, `xl`) to
 *   dictate if it should appear or not at certain screen sizes.
 *
 * Like GridItems, you should set at least one field (usually `xs`) to
 *   true.
 *
 *  - ZeroHeight: {@link https://zeroheight.com/7b3231350/p/54c9c6-grid}
 *  - Material UI: {@link https://v4.mui.com/api/grid/}
 *
 * @param props - {@link OwnUpGridBreakProps}
 */
var OwnUpGridBreak = function OwnUpGridBreak(_ref) {
  var className = _ref.className,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);
  /* Add a class name to the break. */
  var builtClassName = hooks_useCombinedClassName.useCombinedClassName(className, 'break');
  /* Build modified properties to show/hide the breakpoint at certain resolutions */
  var modifiedProps = React.useMemo(function () {
    return breakpoints.BREAKPOINTS.reduce(function (acc, cur) {
      var value = acc[cur];
      if (value === true) {
        acc[cur] = 'auto';
      } else if (value === false) {
        acc[cur] = 0;
      } else {
        acc[cur] = undefined;
      }
      return acc;
    }, props);
  }, [props]);
  return /*#__PURE__*/React__default['default'].createElement(element.StyledGridBreak, _rollupPluginBabelHelpers._extends({
    className: builtClassName
  }, modifiedProps));
};

/**
 * A wrapper around our {@link OwnUpGridItem} component that
 *   contains nothing in it, which can be used to offset grids.
 *
 *  - ZeroHeight: {@link https://zeroheight.com/7b3231350/p/54c9c6-grid}
 *  - Material UI: {@link https://v4.mui.com/api/grid/}
 *
 * @param props - {@link OwnUpGridOffsetProps}
 */
var OwnUpGridOffset = function OwnUpGridOffset(props) {
  return /*#__PURE__*/React__default['default'].createElement(element.OwnUpGridItem, props);
};

exports.OwnUpGridBreak = OwnUpGridBreak;
exports.OwnUpGridOffset = OwnUpGridOffset;
//# sourceMappingURL=element-4fed980b.js.map
